export {
	easeIn,
	easeIn40Out,
	easeIn60Out,
	easeIn80Out,
	easeInOut,
	easeOut,
	linear,
} from '../utils/curves';
export type { AnimationCurve } from '../utils/curves';
